/* Put your custom code here */

$(function(){

	function free_shipping_notification(){

		var $freeShipping = 1250,
		$cart = $(".cart-subtotal").find(".money");
     
		$cartTotal = $cart.text();
      	$cartTotal = $cartTotal.slice(0, -5);
   
		$cartTotal = parseInt($cartTotal.replace(",","").replace(".",""));
      
     

		if( $cartTotal > 0 && $cartTotal < 200 ){
			$(".free-shipping-wrapper").find(".text").show();
			$(".free-shipping-wrapper").find(".free").hide();
			$(".free-shipping-wrapper").find(".total-price").text($freeShipping - $cartTotal);		
		}else if( $cart.length == 0 ){
			$(".free-shipping-wrapper").find(".free").hide();
		}
		else{
			$(".free-shipping-wrapper").find(".text").hide();
			$(".free-shipping-wrapper").find(".free").show();
		}		

		$(document).ajaxStop(function(){		
			$cartTotal = $cart.text();
			$cartTotal = parseInt( $cartTotal.slice(0, -5) );

			if( $cartTotal > 0 && $cartTotal < 200 ){
				$(".free-shipping-wrapper").find(".text").show();
				$(".free-shipping-wrapper").find(".free").hide();
				$(".free-shipping-wrapper").find(".total-price").text($freeShipping - $cartTotal);
			}else if( $cart.length == 0 ){
				$(".free-shipping-wrapper").find(".free").hide();
			}else{
				$(".free-shipping-wrapper").find(".text").hide();
				$(".free-shipping-wrapper").find(".free").show();
			}
		});

	}
	free_shipping_notification();

	


});